import React from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { toggleModal, toggleSpinner } from 'apps/auth/actions/appAction';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import { INCREASE_LIMITS_CONTINUE_CLICKED, NOT_NOW_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { GT_LEVEL, KYC_PROVIDER } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { SUMSUB } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

const PromoReachingLimit = ({ primaryButtonOnClick, toggleSpinner }) => {
    const { reachingLimitTitle, reachingLimitSubTitle, upgradeLimitButton, notNowButton } = usePageMessages();
    const { current_aml_level, hasSumsub } = useExtra();
    const expectedGTLevel = current_aml_level + 1;

    const primaryButtonClickHandler = () => {
        const params = { [GT_LEVEL]: expectedGTLevel };
        if (hasSumsub) {
            params[KYC_PROVIDER] = SUMSUB;
        }
        amplitude.getInstance().logEvent(INCREASE_LIMITS_CONTINUE_CLICKED, params);
        primaryButtonOnClick();
    };

    return (
        <InfoPage
            iconName="speedometer-low-80"
            iconColor="primary"
            headerText={<DangerouslyHtml dangerouslyHtml={reachingLimitTitle} />}
            secondaryText={<DangerouslyHtml dangerouslyHtml={reachingLimitSubTitle} />}
            topButtonType="link"
            topButtonCaption={notNowButton}
            topButtonLink={AUTH_SEND_MAIN_LINK}
            topButtonOnClick={() => {
                toggleSpinner(true);
                amplitude.getInstance().logEvent(NOT_NOW_CLICKED);
            }}
            primaryButtonCaption={upgradeLimitButton}
            primaryButtonOnClick={primaryButtonClickHandler}
        />
    );
};
export default connect(null, { toggleModal, toggleSpinner })(PromoReachingLimit);
